import React, { useState } from "react";
import ActionButton from "../Buttons/ActionButton";
import { ReactComponent as DeleteIcon } from "../../assets/icons/delete.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/edit.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/icons/arrow_down.svg";
import { ReactComponent as CircleIcon } from "../../assets/icons/circle.svg";
import { ReactComponent as NoDataIcon } from "../../assets/icons/no_data.svg";

import { NavLink } from "react-router-dom";
import Text from "./Data/Text";
import Image from "./Data/Image";
import Datetime from "./Data/Datetime";
import Badge from "../Badges/Badge";

interface IProps {
  headers: any;
  items: Array<any>;
  to?: any;
  onDelete?: any;
  actions?: any;
  // onPlay?: any;
  // onStop?: any;
  // actions?: "workers" | "models" | "default";
  tableName?: any;
}

const Table = (props: IProps) => {
  const deleteHandler = (e, row) => {
    e.stopPropagation();
    e.preventDefault();
    props.onDelete(row);
  };

  return props.items && props.items.length > 0 ? (
    <table className="table">
      <thead>
        <tr>
          {props.headers?.map(({ label }, index) => (
            <TableHeaders label={label} key={index} />
          ))}
          <th>
            Actions
            <ArrowDownIcon />
          </th>
        </tr>
      </thead>
      <tbody>
        {props.items?.map((row, index) => (
          <TableRow
            row={row}
            headers={props.headers}
            onDelete={(e) => deleteHandler(e, row)}
            to={props.to && `/${props.to}/${row["id"]}`}
            key={row.id}
            id={row.id}
            actions={props.actions}
          />
        ))}
      </tbody>
    </table>
  ) : (
    <NoData tableName={props.tableName} />
  );
};

const TableHeaders = ({ label }) => (
  <th>
    {label}
    <ArrowDownIcon />
  </th>
);

function get<ObjectType>(object: ObjectType, path: string) {
  const keys = path.split(".");
  let result = object;
  for (const key of keys) {
    result = result[key] === null || undefined ? "Not defined" : result[key];
  }
  return result;
}

const TableRow = ({ row, headers, onDelete, to, actions, id }) => (
  <tr id={id}>
    {to ? (
      <NavLink to={to}>
        <>
          {headers?.map(({ key, type, format }) => {
            var value = get(row, key);
            if (format) value = format(value);
            switch (type) {
              case "text":
                return (
                  <td key={key} style={{ padding: "1rem" }}>
                    <Text>{value}</Text>
                  </td>
                );
              case "text-status":
                return (
                  <td key={key}>
                    <div
                      className={`status-icon ${
                        row[key].status == "online" ? "online" : "offline"
                      }`}
                      style={{ display: "inline-block", paddingTop: "0.2rem" }}
                    >
                      <CircleIcon />
                    </div>
                    <Text className="status-label">{value}</Text>
                  </td>
                );
              case "image":
                return (
                  <td key={key}>
                    <Image row={row}>{value}</Image>
                  </td>
                );
              case "date":
                return (
                  <td key={key}>
                    <Datetime>{value}</Datetime>
                  </td>
                );
              case "badge":
                return (
                  <td key={key}>
                    <Badge label={value} size="medium" />
                  </td>
                );
              default:
                return (
                  <td key={key}>
                    <Text>{value}</Text>
                  </td>
                );
            }
          })}
          <td className="actions">
            {actions ? (
              <div id={id} >
                {actions(row)}
              </div>
            ) : (
              <>
                <ActionButton
                  icon={<EditIcon />}
                  className="list-item-action"
                />
                <ActionButton
                  icon={<DeleteIcon />}
                  className="list-item-action"
                  onClick={(e) => onDelete(e, row)}
                />
              </>
            )}
          </td>
        </>
      </NavLink>
    ) : (
      <>
        {headers?.map(({ key, type, format }) => {
          var value = get(row, key);
          if (format) value = format(value);
          switch (type) {
            case "text":
              return (
                <td key={key} style={{ padding: "1rem" }}>
                  <Text>{value}</Text>
                </td>
              );
            case "text-status":
              return (
                <td key={key}>
                  <div
                    className={`status-icon ${
                      row[key].status == "online" ? "online" : "offline"
                    }`}
                    style={{ display: "inline-block", paddingTop: "0.2rem" }}
                  >
                    <CircleIcon />
                  </div>
                  <Text className="status-label">{value}</Text>
                </td>
              );
            case "image":
              return (
                <td key={key}>
                  <Image row={row}>{value}</Image>
                </td>
              );
            case "date":
              return (
                <td key={key}>
                  <Datetime>{value}</Datetime>
                </td>
              );
            case "badge":
              return (
                <td key={key}>
                  <Badge label={value} size="medium" />
                </td>
              );
            default:
              return (
                <td key={key}>
                  <Text>{value}</Text>
                </td>
              );
          }
        })}
        <td className="actions">
          {actions ? (
            <div id={id}>
              {actions(row)}
            </div>
          ) : (
            <>
              <ActionButton icon={<EditIcon />} className="list-item-action" />
              <ActionButton
                icon={<DeleteIcon />}
                className="list-item-action"
                onClick={(e) => onDelete(e, row)}
              />
            </>
          )}
        </td>
      </>
    )}
  </tr>
);

const NoData = ({ tableName }) => (
  <div style={{ marginTop: "7rem" }}>
    <NoDataIcon style={{ height: "50px", width: "50px" }} />
    <p>No {tableName} to show.</p>
  </div>
);

export default Table;
